// Similar to RegulationManager.cs but for typescript use.
// Holds the list/regulation IDs that are in RegulationManager.cs.

import { DynamicRegulation } from "../Models/Compliance/DynamicRegulation";

export class RegulationManager {

    // The RoHS (Restriction of Hazardous Substances) List
    static RohsListId: string = "67fedc35-951b-4df9-a66e-953c7595fea4";

    // ===============================================================================

    /// The RoHS Regulation ID
    static RohsRegulationId: string = "1c87c8f8-6df6-43ee-b943-ea8801b326ba";

    // ===============================================================================

    /// The EU REACH SVHC Candidate (Annex XVII CMRs) List
    static ReachSvhcCandidateListId: string = "7b423e48-7872-40c5-8aad-8210a60cf125";

    // ===============================================================================

    /// The EU REACH SVHC Candidate Regulation ID
    static ReachSvhcCandidateRegulationId: string = "5e835659-09ca-473e-9795-b97bb3f7411a";

    // ===============================================================================

    /// The EU REACH SVHC Authorization List
    static ReachSvhcAuthorizationListId: string = "53eef5d0-d903-422a-8e40-f35c83711c9c";

    // ===============================================================================

    /// The EU REACH SVHC Authorization Regulation ID
    static ReachSvhcAuthorizationRegulationId: string = "92c53d77-3d75-49d3-8d40-de9c37aefea9";

    // ===============================================================================

    // TODO: KYLE REFCHECK
    /// The EU REACH SVHC Authorization V2 Regulation ID
    static ReachSvhcAuthorizationV2RegulationId: string = "3908f984-c9ad-4b00-a499-e6f035abcda4";

    // ===============================================================================

    /// The Reach CLP Pbt Regulation ID
    static Tsca8a7RegulationId: string = "fe82f7ec-a70e-4c32-a77a-a274aa463c91";

    // ===============================================================================

    /// The International PFAS Regulation ID
    static InternationalPfasRegulationId: string = "b8630ed5-632a-4ef0-aa4e-faee463da90c";

    // ===============================================================================

    /// The Reach CLP Pbt Regulation ID
    static ReachClpPbtRegulationId: string = "3c3d79ce-9ad0-4a50-998a-89548e18dc9a";

    // ===============================================================================

    /// The California Prop 65 List
    static CaProp65ListId: string = "13ab8935-8a03-43d4-b8eb-0d5f056bd500";

    // ===============================================================================

    /// The California Prop 65 Regulation ID
    static CaProp65RegulationId: string = "e1d5cb06-e7ce-4b11-a741-e72f96e3b739";

    // ===============================================================================

    /// The Living Building Challenge Red List
    static LbcRedListListId: string = "c5e3e750-5876-41be-bcdd-6510a5a56693";

    // ===============================================================================

    /// The Conflict Minerals Regulation ID
    static ConflictMineralsRegulationId: string = "10e3e1ef-ec4d-4743-ba91-97f9bc3d208a";

    // ===============================================================================

    /// The Conflict Minerals Template Regulation ID
    static ConflictMineralsTemplateRegulationId: string = "72e08000-7d82-11ee-8501-0800200c9a66";

    // ===============================================================================

    static ConflictMineralsV2RegulationId: string = "8a7b7c95-29df-4a0f-baa8-0db72c1c3fa9";

    // ===============================================================================

    public static ScipComplianceId: string = "c47e8390-95db-4958-b626-92b6a155e317";

    // ===============================================================================

    public static readonly ConegRegulationId: string = "9b4a5c58-330a-4168-8788-608c3cc80fb3";

    // ===============================================================================

    public static readonly EuPopsRegulationId: string = "391f6c85-62d5-4f7b-9712-15edb7935ca4";

    // ===============================================================================

    public static readonly CmrRegulationId: string = "41e2aa02-85c4-4166-b72f-e39ab00ea8cf";

    // ===============================================================================

    public static readonly SaintGobainGenericRegulationId: string = "8e4dcc9b-24b6-4d36-8860-6aea34078f4f";

    // ===============================================================================

    public static readonly ConflictMineralsV2SupplierQuestionnaireRegulationId = "be1733ff-99d7-4494-902f-b55eaa35f6e9";

    // ===============================================================================

    public static getRegulationsAs2GroupsAlphabatized(dynRegs: DynamicRegulation[]) {
        return dynRegs.filter(d => d.isStandardRegulation).orderBy(x => x.config.name)
            .concat(
                dynRegs.filter(d => !d.isStandardRegulation).orderBy(x => x.config.name)
            );
    }
}
